<table class="table table--striped">
  <thead>
    <tr>
      <th translate>address</th>
      <th translate>contact</th>
      <th translate>source</th>
      <th translate>booked</th>
      <th translate>meeting_time</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="(resources$ | async)?.length > 0; else empty">
      <tr *ngFor="let resource of resources$ | async">
        <td dataLabel="address">{{ resource.address }}</td>
        <td dataLabel="contact">
          <a
            [routerLink]="[
              '/crm',
              {
                outlets: {
                  primary: ['contacts', resource.contactId],
                  modal: null
                }
              }
            ]"
          >
            {{ resource.firstName + " " + resource.familyName }}
          </a>
        </td>
        <td dataLabel="source">{{ resource.contactSource }}</td>
        <td dataLabel="booked">
          {{ resource.insertedDate | momentifyCustomFormat }}
        </td>
        <td dataLabel="meeting_time">
          {{ resource.startTime | momentifyCustomFormat }}
        </td>
      </tr>
    </ng-container>

    <ng-template #empty>
      <tr>
        <td class="text-center" colspan="100%" translate>no_sales_meetings</td>
      </tr>
    </ng-template>
  </tbody>
</table>
